var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-sm-100 d-md-flex"},[_c('section',{staticClass:"nav-desktop",staticStyle:{"z-index":"5"}},[_c('NavigationAdmin',{attrs:{"wlistener":_vm.innerWidth}})],1),_c('div',{staticClass:"bg-extra-light pt-4 px-4 ml-1 w-100"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }